function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChristianity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 74.160156 27.988281 L 50.039062 27.988281 L 50.039062 3.328125 L 39.960938 3.328125 L 39.960938 27.988281 L 15.839844 27.988281 L 15.839844 38.25 L 39.960938 38.25 L 39.960938 86.671875 L 50.039062 86.671875 L 50.039062 38.25 L 74.160156 38.25 Z M 74.160156 27.988281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristianity);
export default __webpack_public_path__ + "static/media/christianity.da36c93b60bd50d70a147062e4ebfe7a.svg";
export { ForwardRef as ReactComponent };